var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 14.667H18.3333V16.3337H1.66663V14.667H3.33329V8.83366C3.33329 5.15176 6.31806 2.16699 9.99996 2.16699C13.6819 2.16699 16.6666 5.15176 16.6666 8.83366V14.667ZM15 14.667V8.83366C15 6.07223 12.7614 3.83366 9.99996 3.83366C7.23853 3.83366 4.99996 6.07223 4.99996 8.83366V14.667H15ZM7.49996 18.0003H12.5V19.667H7.49996V18.0003Z",
    fill: "#353535"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBellIcon);
export default __webpack_public_path__ + "static/media/notification-bell-icon.bc910461edb93025b7de127d2024380b.svg";
export { ForwardRef as ReactComponent };